import { ICatalogGroup } from '@features/game/ui/PopupControls';

export const CATALOG: ICatalogGroup[] = [
  {
    title: 'Маты',
    positions: [
      {
        title: 'Мат ферзем и королем',
        value: '8/8/8/8/4k3/8/6K1/7Q w - - 0 1',
      },
      { title: 'Линейный мат', value: '8/8/8/8/4k3/8/6KR/6R1 w - - 0 1' },
      { title: 'Мат ладьей', value: 'r6k/8/8/4K3/8/8/8/8 b - - 0 1' },
      { title: 'Мат двумя слонами', value: 'B6B/8/8/8/8/4k3/6K1/8 w - - 0 1' },
      { title: 'Мат слоном и конем', value: '8/8/8/8/4k3/8/6KN/6B1 w - - 0 1' },
    ],
  },
  {
    title: 'Пешечные окончания простые',
    positions: [
      {
        title: 'Пеш. окон. прост. 1',
        value: '3k4/8/4P3/3K4/8/8/8/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 2',
        value: '8/8/8/2k5/8/2KP4/8/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 3',
        value: '8/8/8/8/8/2k5/2P5/3K4 b - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 4',
        value: '8/8/8/8/4kp2/8/5K2/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 5',
        value: '4k3/8/8/8/8/8/4KP2/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 6',
        value: '8/5k2/8/4K3/5P2/8/8/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 7',
        value: 'k7/8/K7/8/P7/8/8/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 8',
        value: '8/4k3/8/3K4/3P4/8/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 9',
        value: '8/8/p1k3p1/1p3pP1/1P1K1P2/P7/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 10',
        value: '8/8/8/7K/4k3/7P/8/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 11',
        value: '8/7k/8/8/5KP1/8/8/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 12',
        value: '5k2/8/3P4/8/6K1/8/8/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 13',
        value: '8/p7/8/k7/5K2/8/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 14',
        value: 'k7/8/1KP5/8/8/8/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 15',
        value: '8/7k/8/8/5KP1/8/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 16',
        value: '8/8/3k4/8/8/5P2/5K2/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 17',
        value: '2k5/8/8/8/1PK5/8/8/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 18',
        value: '8/8/1k6/8/8/8/2KP4/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 19',
        value: '8/3p4/8/2k1P3/8/1K6/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 20',
        value: '8/8/8/2p5/8/8/1kP5/3K4 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 21',
        value: '8/2p5/3P4/2k5/8/1K6/8/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 22',
        value: '8/8/1k1p4/3P1K2/8/8/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 23',
        value: '8/8/1k1p4/3P1K2/8/8/8/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 24',
        value: '8/5ppp/8/5PPP/8/k7/8/K7 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 25',
        value: '8/1pp5/p2p4/P2P4/1PP5/7k/6p1/6K1 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 26',
        value: '8/p7/1p3K1p/1P6/P1P1k3/8/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 27',
        value: '8/8/5p2/4k1pp/p1P4P/P3K1P1/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 28',
        value: '8/pp1k1p2/4p1pp/7P/3P2P1/5P2/PP1K4/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 29',
        value: '8/1p6/1Pp5/2Pp2k1/3P1p2/4P3/5K2/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 30',
        value: '6k1/p4ppp/8/8/8/8/PP3PPP/6K1 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 31',
        value: '8/pp2pk2/8/8/8/8/PP3K1P/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 32',
        value: '8/p4K2/P7/8/8/8/1k6/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 33',
        value: '8/6p1/6K1/8/7P/5k2/7P/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 34',
        value: '8/7k/p6P/6K1/P7/8/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 35',
        value: '6R1/8/8/5p2/5k1r/8/6K1/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. прост. 36',
        value: '8/8/5pk1/5r2/5R2/5K2/8/8 b - - 0 1',
      },
    ],
  },
  {
    title: 'Пешечные окончания сложные',
    positions: [
      {
        title: 'Пеш. окон. сложн. 1',
        value: '8/8/3K1k2/5p1p/4p1p1/4P1P1/5PP1/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 2',
        value: '8/7p/1p3k2/p3pp2/1PP1PP2/5K2/7P/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 3',
        value: '8/2p4p/5p2/p2p3k/5P2/1PP4P/P2K4/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 4',
        value: '8/5p2/5p1p/1p1k4/1P3PPP/8/6K1/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 5',
        value: '8/5pp1/7p/5P1P/2p3P1/2k5/5P2/2K5 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 6',
        value: '8/4kp2/6p1/7p/P7/2K3P1/7P/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 7',
        value: '8/p5pp/1pp5/3k4/P2P4/2PK4/6PP/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 8',
        value: '6k1/pp6/2p4p/6p1/8/1PPP3P/2P2K2/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 9',
        value: '8/8/8/p2k1p1p/3P2p1/1P1K2P1/6P1/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 10',
        value: '8/8/2k5/4pppp/8/P3KPP1/7P/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 11',
        value: '8/8/2p5/p1k1p2p/4P2P/PP1K4/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 12',
        value: '6K1/8/6k1/8/8/p7/P7/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 13',
        value: '8/8/p6p/P3k2P/8/8/2K5/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 14',
        value: '8/1pk5/3p4/1K1Pp1p1/4P1Pp/P6P/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 15',
        value: '8/8/5k1p/8/4K1PP/8/8/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 16',
        value: '8/8/4k2p/8/5KPP/8/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 17',
        value: '8/2Pk2p1/7p/pp6/2p1K1P1/P1P4P/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 18',
        value: '8/7p/2p5/p1k1ppp1/2P5/1PK1PP2/6PP/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 19',
        value: '8/6p1/p7/1p2k2p/1P3p1P/P2K4/5PP1/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 20',
        value: '8/p4k2/6p1/Pp1p1pKp/1P5P/2P2PP1/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 21',
        value: '2k5/8/p1P5/P2K4/8/8/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 22',
        value: '8/3k3p/5p2/p1p2Pp1/1pP3P1/1P1K3P/P7/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 23',
        value: '1k6/1P3p2/P3p1p1/3pP1P1/1p3P2/4K3/8/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 24',
        value: 'R7/P5k1/3K1p2/6p1/4P1P1/8/8/r7 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 25',
        value: '8/1p3pp1/p1krpn1p/P6P/2P2PP1/2B5/1PK5/4R3 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 26',
        value: '3Rb2r/5kp1/p4p2/4pN2/6pP/4P3/PP3K2/8 w - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 27',
        value: '8/p5k1/3p3p/4n1p1/3pq3/1P3PP1/P2Q3P/4N1K1 b - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 28',
        value: '6K1/5p1r/5P2/8/2k5/8/8/8 b - - 0 1',
      },
      {
        title: 'Пеш. окон. сложн. 29',
        value: '8/1p1Q4/2p3pk/2P2r2/6K1/8/8/8 w - - 0 1',
      },
    ],
  },
  {
    title: 'Ферзь против пешки',
    positions: [
      {
        title: 'Ферзь против пешки 1',
        value: '8/8/8/8/8/p7/1k6/3Q2K1 w - - 0 1',
      },
      {
        title: 'Ферзь против пешки 2',
        value: '7Q/8/3K4/8/8/8/4pk2/8 w - - 0 1',
      },
      {
        title: 'Ферзь против пешки 3',
        value: '8/PK6/8/q7/8/2k5/8/8 b - - 0 1',
      },
      {
        title: 'Ферзь против пешки 4',
        value: '8/5PK1/8/5q2/8/8/7k/8 b - - 0 1',
      },
      {
        title: 'Ферзь против пешки 5',
        value: 'Q6K/8/7p/8/8/8/pk6/8 w - - 0 1',
      },
    ],
  },
  {
    title: 'Ладья против пешки',
    positions: [
      {
        title: 'Ладья против пешки 1',
        value: 'RK6/8/6k1/7p/8/8/8/8 w - - 0 1',
      },
      {
        title: 'Ладья против пешки 2',
        value: '6KR/8/pk6/8/8/8/8/8 b - - 0 1',
      },
      {
        title: 'Ладья против пешки 3',
        value: '3K4/5R2/8/1pk5/8/8/8/8 w - - 0 1',
      },
    ],
  },
  {
    title: 'Лад. окончания простые',
    positions: [
      {
        title: 'Лад. окон. прост. 1',
        value: '4k2r/R7/8/3KP3/8/8/8/8 b - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 2',
        value: '3k4/8/8/1K6/1P6/8/3r4/2R5 w - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 3',
        value: 'R7/6k1/8/8/8/8/p6K/r7 w - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 4',
        value: 'K7/P4k2/8/8/8/8/4R3/1r6 w - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 5',
        value: 'K7/P1k5/8/8/8/8/4R3/1r6 w - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 6',
        value: '4K3/4P1k1/8/8/8/8/r7/5R2 b - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 7',
        value: '4K3/4P1k1/8/8/8/8/1r6/5R2 b - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 8',
        value: '4R3/4K1k1/4P3/8/8/8/8/r7 w - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 9',
        value: '8/8/R7/8/p4k2/8/6K1/r7 w - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 10',
        value: '1r6/8/4k3/8/1P6/1K6/8/3R4 w - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 11',
        value: '1r6/8/8/4k3/4P3/R2P4/3K4/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 12',
        value: '1r6/2p5/P2p4/1P1Pp1k1/2P4p/2K5/8/R7 w - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 13',
        value: '5k2/1R6/p5p1/P6p/1Pr4P/8/8/1K6 w - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 14',
        value: '3r4/2k5/2p5/2P4R/ppP1p2P/5pP1/P4P2/2K5 b - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 15',
        value: '8/p4p2/6k1/2Pp3p/7P/P2R1KP1/r7/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 16',
        value: '5k2/1R4p1/5p2/1P4p1/P3p3/4P3/4KP2/r7 w - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 17',
        value: '6k1/8/8/8/6P1/6K1/1r6/R7 w - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 18',
        value: '5k2/8/R4K2/5P2/8/8/1r6/8 b - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 19',
        value: '8/r5k1/5p2/3R1K1P/6P1/8/8/8 b - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 20',
        value: '8/5pk1/r5pp/P7/3R3P/6P1/5PK1/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 21',
        value: '8/5kpp/p4p2/1p6/2rP1P2/P3K1P1/1R5P/8 b - - 0 1',
      },
      {
        title: 'Лад. окон. прост. 22',
        value: '8/8/4k3/7R/2p1p3/2P5/1P2KP1p/7r b - - 0 1',
      },
    ],
  },
  {
    title: 'Ладейные окончания сложные',
    positions: [
      {
        title: 'Лад. окон. сложн. 1',
        value: '8/6k1/R7/1r5P/5PK1/8/8/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 2',
        value: '8/5pk1/2R2p2/8/8/5PK1/r5PP/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 3',
        value: '8/1r3kp1/5p1p/5K1P/4PPP1/8/R7/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 4',
        value: '2R5/5ppk/7p/7P/3KPPP1/r7/8/8 b - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 5',
        value: '8/5pkp/6p1/R7/1r6/4PKPP/5P2/8 b - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 6',
        value: 'R7/5pk1/6p1/7p/7P/P4KP1/r4P2/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 7',
        value: '8/pr2k1pp/8/R7/8/4PK2/P5PP/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 8',
        value: '2k5/p5pp/2p5/4P3/2K5/2p1P3/r4PPP/2R5 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 9',
        value: '6k1/5p1p/4p1p1/P7/3r4/7P/5PP1/1R4K1 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 10',
        value: '6k1/5p1p/4p1p1/P7/3r4/7P/5PP1/1R4K1 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 11',
        value: '8/8/5R2/3P4/3kP2p/1r4p1/4K1P1/8 b - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 12',
        value: '3r2k1/5p2/P5pp/4P3/2p5/R6P/6PK/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 13',
        value: '8/1R3pk1/4p3/p1r1P2p/5Pp1/1P4P1/P2K4/8 b - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 14',
        value: '1r4k1/p4p2/4p1p1/PP2P2p/1P6/6P1/4p2P/2R3K1 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 15',
        value: 'R7/4k1p1/P6p/5p1P/5P2/3p4/r5P1/4K3 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 16',
        value: '3r2k1/4p2p/6p1/pp2R3/5P2/8/1PP4P/7K b - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 17',
        value: '2R5/8/8/6p1/3k2K1/r1p2PP1/6P1/8 b - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 18',
        value: '8/8/P2Rp1p1/4r1kp/1p6/8/1PP4P/2K5 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 19',
        value: '8/4Rp2/5kp1/1P5p/2K4P/6P1/1r6/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 20',
        value: '8/1pk2p2/p3pprp/8/2P4R/1P3P2/P4KPP/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 21',
        value: '8/4kp2/3R2p1/1p2P1K1/1Pr2PP1/8/8/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 22',
        value: '8/p4p2/1p2p3/3p1pPk/1R1P1P2/P6K/1P1r2P1/8 b - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 23',
        value: '2r3k1/5p1p/p1p3p1/2Rp4/8/1P2PP2/P5PP/5K2 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 24',
        value: '8/8/6pp/3k1p2/3Pp3/p3P1P1/Pr1R3P/3K4 b - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 25',
        value: '8/8/3P3p/6pk/6p1/8/2R3PK/4r3 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 26',
        value: '2r3k1/6pp/4P3/1p6/p2K4/1P5P/5RP1/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 27',
        value: '5k2/p1p4R/1pr5/3p1pP1/P2P1P2/2P2K2/8/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 28',
        value: '8/pp2r1k1/2p1p3/3pP2p/1P1P1P1P/P5KR/8/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 29',
        value: '3r4/5kp1/3pR2p/2pP1K1P/2P3P1/8/8/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 30',
        value: '2r5/p3kp2/1p3p2/1K1R3P/2P1P3/8/P7/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 31',
        value: '8/8/6pk/5p1p/P4P1P/6P1/1r6/3R3K w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 32',
        value: '8/5p2/k3r1p1/P6p/5K1P/6P1/R4P2/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 33',
        value: '8/8/6k1/7p/7P/3r2P1/KP3R2/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 34',
        value: '8/1r6/5pp1/P2k4/4R1PK/5P2/8/8 b - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 35',
        value: '7r/p4k2/3p4/2p2K2/2P2P1p/P7/8/5R2 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 36',
        value: '3k4/R7/3r2p1/7p/4K2P/6P1/5P2/8 b - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 37',
        value: '8/5pp1/4p2k/R6p/5P1P/3r4/5KP1/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 38',
        value: '8/2R2pk1/6p1/4P1Kp/5P2/6P1/4r2P/8 w - - 0 1',
      },
      {
        title: 'Лад. окон. сложн. 39',
        value: '6R1/3r4/8/4k1p1/4pp2/7P/5PK1/8 b - - 0 1',
      },
    ],
  },
  {
    title: 'Коневые окончания',
    positions: [
      {
        title: 'Коневое окон. 1',
        value: '8/5nk1/8/6PP/5NK1/8/8/8 w - - 0 1',
      },
      {
        title: 'Коневое окон. 2',
        value: '5k2/p1n2ppp/8/8/8/8/PP3PPP/4N1K1 w - - 0 1',
      },
      {
        title: 'Коневое окон. 3',
        value: '5k2/p4p1p/1p4p1/3np3/P7/5P2/1PN2KPP/8 b - - 0 1',
      },
      {
        title: 'Коневое окон. 4',
        value: '8/4n2p/1p1k1p2/5p1P/P1K5/5PP1/4N3/8 w - - 0 1',
      },
      {
        title: 'Коневое окон. 5',
        value: '3n4/8/2p1pNk1/1pPpP3/pP1P2K1/8/1P6/8 w - - 0 1',
      },
      {
        title: 'Коневое окон. 6',
        value: '8/8/3p3p/2pPp3/1pP1Pp1k/pP3Pn1/P4K2/6N1 b - - 0 1',
      },
      {
        title: 'Коневое окон. 7',
        value: '8/6kp/5p2/1n1N2p1/2p5/6P1/1P3PKP/8 w - - 0 1',
      },
    ],
  },
  {
    title: 'Одноцветные слоны',
    positions: [
      {
        title: 'Одноцветные слоны 1',
        value: '8/8/3K4/1BP5/8/5b2/5k2/8 w - - 0 1',
      },
      {
        title: 'Одноцветные слоны 2',
        value: '3b4/8/8/3K1k2/1P6/2B5/8/8 b - - 0 1',
      },
      {
        title: 'Одноцветные слоны 3',
        value: '8/8/4b3/6k1/8/8/4B1PP/6K1 b - - 0 1',
      },
      {
        title: 'Одноцветные слоны 4',
        value: '8/7p/4k3/8/2PBK3/7P/8/4b3 w - - 0 1',
      },
      {
        title: 'Одноцветные слоны 5',
        value: '5b2/5p2/6p1/7p/2kp2PB/5P1P/3K4/8 b - - 0 1',
      },
      {
        title: 'Одноцветные слоны 6',
        value: '8/6pp/p1k2p2/3pb3/P7/3KBP1P/6P1/8 b - - 0 1',
      },
      {
        title: 'Одноцветные слоны 7',
        value: '8/p7/3bk3/3p4/3P2p1/1P1K2P1/8/4B3 b - - 0 1',
      },
      {
        title: 'Одноцветные слоны 8',
        value: 'b7/4kp2/p1p1p1p1/4P1Kp/1P2B2P/8/5PP1/8 w - - 0 1',
      },
      {
        title: 'Одноцветные слоны 9',
        value: '8/1b6/p1pk1p1p/P4Pp1/1P1K2P1/7P/4B3/8 w - - 0 1',
      },
      {
        title: 'Одноцветные слоны 10',
        value: '6k1/2b2ppp/p7/8/8/7P/PP3PP1/4B1K1 w - - 0 1',
      },
      {
        title: 'Одноцветные слоны 11',
        value: '8/8/8/1p2bk1p/7P/4KP2/8/4B3 b - - 0 1',
      },
    ],
  },
  {
    title: 'Разноцветные слоны',
    positions: [
      {
        title: 'Разноцветные слоны 1',
        value: '8/2k1b3/2P5/3K1P1B/8/8/8/8 w - - 0 1',
      },
      {
        title: 'Разноцветные слоны 2',
        value: '8/4k3/8/4PP2/4K3/8/b7/4B3 w - - 0 1',
      },
      {
        title: 'Разноцветные слоны 3',
        value: '8/4k3/8/3P4/b3P3/4K3/3B4/8 b - - 0 1',
      },
      {
        title: 'Разноцветные слоны 4',
        value: '4b3/1k2B2p/1p6/2p2p2/4p3/7P/PPP2PPK/8 b - - 0 1',
      },
      {
        title: 'Разноцветные слоны 5',
        value: '6k1/5p2/p3b3/1p1p3P/3B4/2P5/PPPK4/8 w - - 0 1',
      },
      {
        title: 'Разноцветные слоны 6',
        value: '2b5/2p5/8/2Pp1ppk/p2P3p/5PP1/5K1P/2B5 b - - 0 1',
      },
      {
        title: 'Разноцветные слоны 7',
        value: '8/1p6/pBp1k1p1/P6p/1P2PK1P/1b3P2/6P1/8 w - - 0 1',
      },
      {
        title: 'Разноцветные слоны 8',
        value: '2b3k1/5ppp/p7/8/8/8/PP3PPP/4B1K1 w - - 0 1',
      },
    ],
  },
  {
    title: 'Слон против коня',
    positions: [
      {
        title: 'Слон против коня 1',
        value: '5k2/3b2pp/p3p3/1p1pP3/8/2P5/PPN3PP/6K1 w - - 0 1',
      },
      {
        title: 'Слон против коня 2',
        value: '7k/p7/6p1/2pB4/8/2Pn2P1/P7/3K4 w - - 0 1',
      },
      {
        title: 'Слон против коня 3',
        value: '6k1/p2b1ppp/8/8/3N4/1P5P/5PP1/6K1 b - - 0 1',
      },
      {
        title: 'Слон против коня 4',
        value: '5n2/8/1p1k1p1p/p1p2P2/P4KPP/2P5/1P2B3/8 w - - 0 1',
      },
      {
        title: 'Слон против коня 5',
        value: '8/8/2k3p1/5p2/2KP3p/2N1bP1P/6P1/8 w - - 0 1',
      },
      {
        title: 'Слон против коня 6',
        value: '8/2kb4/p1p2pp1/2Pp4/3N1PP1/1P4K1/P7/8 w - - 0 1',
      },
    ],
  },
  {
    title: 'Ладья против слона',
    positions: [
      {
        title: 'Ладья против слона 1',
        value: 'kb6/8/2K5/8/8/8/6R1/8 w - - 0 1',
      },
      {
        title: 'Ладья против слона 2',
        value: '6k1/5R2/6K1/8/3b4/8/8/8 b - - 0 1',
      },
      {
        title: 'Ладья против слона 3',
        value: '8/8/3k4/4p3/3bP3/3K4/8/7R b - - 0 1',
      },
      {
        title: 'Ладья против слона 4',
        value: '8/5pk1/6p1/3K3p/8/7P/2R2PP1/b7 w - - 0 1',
      },
    ],
  },
  {
    title: 'Ладья против коня',
    positions: [
      {
        title: 'Ладья против коня 1',
        value: '8/8/3kn3/3p3R/3P4/4K3/8/8 w - - 0 1',
      },
      {
        title: 'Ладья против коня 2',
        value: '8/2n5/5pkp/6p1/4K3/R4PP1/7P/8 b - - 0 1',
      },
    ],
  },
  {
    title: 'Ферзь против других фигур',
    positions: [
      {
        title: 'Ферзь против др. фигур 1',
        value: '8/8/8/8/8/p7/1k6/3Q2K1 w - - 0 1',
      },
      {
        title: 'Ферзь против др. фигур 2',
        value: '7Q/8/3K4/8/8/8/4pk2/8 w - - 0 1',
      },
      {
        title: 'Ферзь против др. фигур 3',
        value: '8/PK6/8/q7/8/2k5/8/8 b - - 0 1',
      },
      {
        title: 'Ферзь против др. фигур 4',
        value: '8/5PK1/8/5q2/8/8/7k/8 b - - 0 1',
      },
      {
        title: 'Ферзь против др. фигур 5',
        value: 'Q6K/8/7p/8/8/8/pk6/8 w - - 0 1',
      },
      {
        title: 'Ферзь против др. фигур 6',
        value: 'K7/8/4Q3/8/8/6k1/7p/8 w - - 0 1',
      },
      {
        title: 'Ферзь против др. фигур 7',
        value: '8/8/8/4k3/5b2/8/6Q1/7K w - - 0 1',
      },
      {
        title: 'Ферзь против др. фигур 8',
        value: '8/8/8/3nk3/8/8/6Q1/7K w - - 0 1',
      },
      {
        title: 'Ферзь против др. фигур 9',
        value: '8/8/8/3rk3/8/8/6Q1/7K w - - 0 1',
      },
      {
        title: 'Ферзь против др. фигур 10',
        value: '8/8/8/8/8/p7/1k6/3Q2K1 w - - 0 1',
      },
      {
        title: 'Ферзь против др. фигур 11',
        value: '7Q/8/3K4/8/8/8/4pk2/8 w - - 0 1',
      },
      {
        title: 'Ферзь против др. фигур 12',
        value: '8/PK6/8/q7/8/2k5/8/8 b - - 0 1',
      },
      {
        title: 'Ферзь против др. фигур 13',
        value: '8/5PK1/8/5q2/8/8/7k/8 b - - 0 1',
      },
      {
        title: 'Ферзь против др. фигур 14',
        value: 'Q6K/8/7p/8/8/8/pk6/8 w - - 0 1',
      },
      {
        title: 'Ферзь против др. фигур 15',
        value: 'K7/8/8/8/8/6k1/6p1/6Q1 w - - 0 1',
      },
    ],
  },
];
